import PanelsDevelopmentMethodology from './PanelsDevelopmentMethodology'

export default PanelsDevelopmentMethodology



// WEBPACK FOOTER //
// ./src/pages/PanelsDevelopmentMethodology/index.js